// @ts-expect-error untyped
import config from 'quartz-config-loader?{"forApp":true}!';
export const quartzConfig = config;